/* eslint-disable */
// STATUS_SIDE — maps each working (stage, full_status) pair to "who the ball
// is with" for the Delay Report export (David-confirmed 2026-05-28):
//   'factory'  → awaiting a factory reply (include in factory chase-list)
//   'designer' → awaiting the designer (designer-side delay)
//   'neither'  → terminal / transition status (exclude — nobody is waiting)
//
// Outer keys use STAGES.* (computed) so they can never drift from stage_status.
// Inner keys are the EXACT STATUS_DAYS keys (shared.js:94-120) — em-dash (—),
// spacing and capitalization must match verbatim. Verified 1:1 against
// STATUS_DAYS (4 Drawing + 9 Hand + 6 Color). A status NOT present here
// resolves to undefined → treated as "exclude" (we never guess a side).

import { STAGES } from '../shared';

export const STATUS_SIDE = {
  [STAGES.DRAWING]: {
    '1st drawing': 'factory',
    'Designer request': 'designer',
    'Fty reply': 'factory',
    'Drawing approved': 'neither',
  },
  [STAGES.HAND]: {
    'Proto / Hand made requested': 'factory',
    'Proto / Hand made received': 'designer',
    'Revise drawing — Designer request': 'designer',
    'Revise drawing — Fty reply': 'factory',
    'Revise proto / Hand made — Designer request': 'designer',
    'Revise proto / Hand made — Fty reply': 'factory',
    'Stay in Proto / Hand made': 'neither',
    'Proto / Hand made approved': 'neither',
    'No need Proto / Hand made': 'neither',
  },
  [STAGES.COLOR]: {
    'Color samples requested': 'factory',
    'Revise drawing — Designer request': 'designer',
    'Revise drawing — Fty reply': 'factory',
    'Revise colors — Designer request': 'designer',
    'Revise colors — Fty reply': 'factory',
    'Colors received': 'neither',
  },
};

/**
 * Returns 'factory' | 'designer' | 'neither' for a (stage, status) pair, or
 * undefined when the pair is unknown (legacy/stopped/unclassified status).
 * Both undefined and 'neither' should be excluded from the delay report.
 */
export function getStatusSide(stage, status) {
  return STATUS_SIDE?.[stage]?.[status];
}
